module.exports = __webpack_public_path__ + "static/media/attr_health_checkup.69bde166.svg";